module.exports = __webpack_public_path__ + "img/agent_machine.cf7dfc2c.png";